import { render } from "./DiscardSubmissionButton.vue?vue&type=template&id=0f0f4313"
import script from "./DiscardSubmissionButton.vue?vue&type=script&lang=js"
export * from "./DiscardSubmissionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__